import { REQUEST_THREAD_ENTITY } from '../../../../constants/entity'
import { FILTER_BAR_FILTER_TRIGGER_VARIANT, FilterBar } from '../../../Filter'
import { FilterDivider } from '../../../FilterDivider'
import { getRequestThreadsSingleFieldApi } from '../RequestProfileTabEmails.api'
import {
  IS_REQUEST_PROFILE_TAB_EMAILS_SEARCH_ENABLED,
  REQUEST_PROFILE_TAB_EMAILS_FILTER_STATE_SUB,
  REQUEST_PROFILE_TAB_EMAILS_PERMANENT_FILTERS,
} from '../RequestProfileTabEmails.constants'
import {
  getRequestProfileTabEmailsPermanentFilters,
  parseRequestProfileTabEmailsPermanentFilters,
} from '../RequestProfileTabEmails.utils'
import { RequestProfileTabEmailsAddButton } from '../RequestProfileTabEmailsAddButton'
import { RequestProfileTabEmailsSearch } from '../RequestProfileTabEmailsSearch'

import { isRequestProfileTabEmailsToolbarFilterBarShown } from './RequestProfileTabEmailsToolbar.utils'

import * as styles from './RequestProfileTabEmailsToolbar.module.css'

function RequestProfileTabEmailsToolbar({
  availableFilters,
  filterValues,
  isFilterDisabled,
  isSkeleton,
  ordering,
  pagination,
  requestId,
  search,
  setFilterValues,
  onChangeSearch,
  onClearSearch,
  onReload,
  onSelectRecipientType,
}) {
  return (
    <div className={styles.toolbar}>
      <div className={styles.filters}>
        {IS_REQUEST_PROFILE_TAB_EMAILS_SEARCH_ENABLED ? (
          <>
            <RequestProfileTabEmailsSearch
              isSkeleton={isSkeleton}
              value={search}
              onChange={onChangeSearch}
              onClear={onClearSearch}
            />
            {isRequestProfileTabEmailsToolbarFilterBarShown({
              availableFilters,
              isSkeleton,
            }) ? (
              <FilterDivider />
            ) : null}
          </>
        ) : null}
        <FilterBar
          hideFilterTemplateSkeleton
          responsive
          apiUrl={getRequestThreadsSingleFieldApi(requestId)}
          availableFilters={availableFilters}
          className={styles.filterBar}
          disabled={isFilterDisabled}
          entity={REQUEST_THREAD_ENTITY}
          excludeFilters={REQUEST_PROFILE_TAB_EMAILS_PERMANENT_FILTERS}
          filterTriggerVariant={FILTER_BAR_FILTER_TRIGGER_VARIANT.COMPACT_ICON}
          filterValues={filterValues}
          getPermanentFilters={getRequestProfileTabEmailsPermanentFilters}
          isSkeleton={isSkeleton}
          objectId={requestId}
          ordering={ordering}
          pagination={{ per_page: pagination?.pageSize }}
          parsePermanentFilters={parseRequestProfileTabEmailsPermanentFilters}
          setFilterValues={setFilterValues}
          sub={REQUEST_PROFILE_TAB_EMAILS_FILTER_STATE_SUB}
          onReload={onReload}
        />
      </div>
      <div className={styles.addButton}>
        <RequestProfileTabEmailsAddButton onSelect={onSelectRecipientType} />
      </div>
    </div>
  )
}

export default RequestProfileTabEmailsToolbar
